import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    giftCards: builder.query({
      query: (params) => generateURL('/api/gift_cards', params, false),
      providesTags: ['gift_cards'],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGiftCardsQuery } = apiSlice;
